import script from "./CoachingSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./CoachingSettings.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__